module.exports = __webpack_public_path__ + "static/media/roof.3eb09ea1.jpg";